var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visibleOperateDom ? _c('div', {
    staticClass: "operate-content"
  }, [_c('hiddenDom', {
    on: {
      "title-show": _vm.contentShow
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };